import { useContext } from 'react'
import { useSignOut as _useSignOut } from 'react-firebase-hooks/auth'
import { auth } from '@BUP/configs/Firebase'
import { TrackerContext } from '@BUP/contexts/tracker.context'
import { useHistory } from 'react-router-dom'

const useSignOut = () => {
  const tracker = useContext(TrackerContext)
  const [_signOut, loading, error] = _useSignOut(auth)
  const history = useHistory()

  const signOut = async () => {
    const success = await _signOut()
    if (success) {
      if (tracker) tracker.reset()
      history.push('/login')
    }
  }

  return {
    signOut,
    loading,
    error
  }
}

export default useSignOut
